import * as PIXI from "pixi.js";
import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { BontrollerComponent } from "src/app/interface-components/bontroller/bontroller.component";
import { HeaderBarComponent } from "src/app/interface-components/header-bar/header-bar.component";
import { NewHolderComponent } from "src/app/interface-components/new-holder/new-holder.component";
import { cameraActions } from "src/app/state/camera/camera.actions";
import { DebrisService } from "../../ambients/debris-service";
import { MapInputService } from "../../inputs/input-middlewares/map-input.middleware";
import { ThreeInputService } from "../../inputs/input-middlewares/three-input.middleware";
import { InputService } from "../../inputs/services/input.service";
import { EventsWebsocketService } from "../../../services/entities/events-websocket.service";
import { ThreeService } from "../../rendering/threejs/three.service";
import { CanvasState } from "../../surface/canvas/canvass.state";
import { SurfaceService } from "../../surface/surface.service";
import { EventSenderService } from "../event-sender.service";
import { FloorPlaneService } from "../../ambients/floor-plane.service";
import {CanvasService} from "../../surface/canvas/canvas.service";

@Component({
  selector: 'classic-binst',
  standalone: true,
  imports: [HeaderBarComponent, NewHolderComponent, BontrollerComponent],
  templateUrl: './classic-binst.component.html',
  styleUrl: './classic-binst.component.scss'
})
export class ClassicBinstComponent {

  constructor(
    private three: ThreeService,
    private threeInputService: ThreeInputService,
    private inputService: InputService,
    private mapInputService: MapInputService,
    private canvasService: CanvasService,
    private surfaceService: SurfaceService,
    private debrisService: DebrisService,
    private eventSenderService: EventSenderService,
    private websocketService: EventsWebsocketService,
    private floorPlaneService: FloorPlaneService,
    private store: Store,
  ) {}

  @ViewChild("canvas")
  private canvasRef: ElementRef;

  public rotationSpeedX = 0.005;
  public rotationSpeedY = 0.005;
  animationValue = 0;

  debug = false;
  searchActive = false;

  private get canvas(): HTMLCanvasElement {
    return this.canvasRef.nativeElement;
  }

  activateSearch(enabled: boolean) {
    this.searchActive = enabled;
    this.store.dispatch(
      cameraActions.triggeredCanvasResizeAnimation({ durationMs: 500 }),
    );
  }

  async ngAfterViewInit(): Promise<void> {
    this.canvasService.setDocument(document);
    await this.canvasService.setupCanvas(2500, 2500);
    this.surfaceService.setup(2500, 2500);
    this.inputService.makeHtmlElementTouchable(this.canvas);
    this.three.createScene(this.canvas, window, 0x10100e, this.debug);
    // await this.debrisService.setup(10);
    await this.floorPlaneService.setup();
    this.three.onRender(async (timeDelta) => {
      if (this.surfaceService) {
        await this.surfaceService.render(timeDelta);
      }
      if (this.canvasService) {
        await this.canvasService.render();
      }
      if (this.debrisService) {
        await this.debrisService.update(timeDelta);
      }
    });
    await this.inputService.addInputMiddleware("three", this.threeInputService);
    await this.inputService.addInputMiddleware("map", this.mapInputService);
    this.three.startRenderLoop();
    await this.surfaceService.updateCamera()
    // const canv = CanvasState.canvass.values().next().value;
  }
}
